import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ListNameLabel from 'flow-doctor-lib/components/common/ListNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicReenrollmentListFilterRenderer = ({
  portalId,
  reEnrollmentTriggerSet
}) => {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "flow-doctor-lib.reEnrollmentTriggerSets.dynamicList_jsx",
    elements: {
      ListNameLabel,
      b: 'b'
    },
    options: {
      portalId,
      listId: reEnrollmentTriggerSet[0].id,
      isClassic: true,
      showId: getIsInternal()
    }
  });
};
export default ClassicReenrollmentListFilterRenderer;